import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Load user data from localStorage
const loadUserDataFromLocalStorage = () => {
  const user = localStorage.getItem('user');
  const token = localStorage.getItem('token');
  const adresse_facturation = localStorage.getItem('adresse_facturation');
 // return user && token && adresse_facturation ? { user: JSON.parse(user), token , adresse_facturation: JSON.parse(adresse_facturation)} : null;

 try {
 
  return user && token && adresse_facturation 
    ? { 
      
        user: JSON.parse(user), 
        token, 
        adresse_facturation: adresse_facturation ? JSON.parse(adresse_facturation): null
      }
    : null;
   
} catch (error) {
  // console.error("Error parsing localStorage data:", error);
  return null; // Return null in case of parse error
}
};

const initialState = loadUserDataFromLocalStorage() || {
  isAuthenticated: false,
  isAuthenticatedRdv: false,
  user: null,
  token: null,
  adresse_facturation: null,
  loading: false,
  error: null,
};
// Thunk to update user profile
export const updateUserProfile = createAsyncThunk(
  'user/updateProfile',
  async (userData, { getState, rejectWithValue }) => {
    try {
      const { user: { token } } = getState();
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}update-profile`,
        userData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      return response.data.user;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);
// Thunk to update user profile
export const registerInfo = createAsyncThunk(
  'user/updateProfile',
  async (userData, { getState, rejectWithValue }) => {
    try {
      const { user: { token } } = getState();
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}update-profile`,
        userData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      return response.data.user;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);
// Thunk to change password
export const changePassword = createAsyncThunk(
  'user/changePassword',
  async (passwordData, { getState, rejectWithValue }) => {
    try {
      const { user: { token } } = getState();
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}profile/password`, // Matches Route::put('/profile/password')
        passwordData,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      return response.data; // { message: "Mot de passe mis à jour avec succès" }
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);
// Thunk to delete Account
export const deleteAccount = createAsyncThunk(
  'user/deleteAccount',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { user: { token } } = getState();
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}user/soft-delete`,
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);
// Thunk to delete Account
export const refreshToken = createAsyncThunk(
  'user/refreshToken',
  async (_, { getState, rejectWithValue }) => {
    try {
      const { user: { token } } = getState();
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}refresh-token`, // Typical refresh endpoint
        {},
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          }
        }
      );
      return response.data; // Should return { token: newToken, user: userData }
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || error.message);
    }
  }
);
const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = null;
      localStorage.clear();
    },
    loginSuccess: (state, action) => {
      // console.log("belling adress: ",action.payload)
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.adresse_facturation = action.payload.adresse_facturation;
      state.loading = false;
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      localStorage.setItem('token', action.payload.token);
      action.payload.adresse_facturation && localStorage.setItem('adresse_facturation', JSON.stringify(action.payload.adresse_facturation));
      
    },
    updateUserData: (state, action) => {
 
      state.user = action.payload.user;
      localStorage.setItem('user', JSON.stringify(action.payload.user));
      state.isAuthenticated = true;
    },
    loginFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    registerStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    registerSuccess: (state) => {
      state.loading = false;
    },
    registerPrestaSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.token = action.payload.token;
      state.loading = false;
      localStorage.setItem('token', action.payload.token);
    },
    registerFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.token = null;
      state.adresse_facturation = null;
      // localStorage.removeItem('user');
      // localStorage.removeItem('token');
      // localStorage.removeItem('adresse_facturation');
       localStorage.clear();
    },
    initialize: (state, action) => {
      state.isAuthenticated = action.payload?.isAuthenticated || false;
      state.user = action.payload?.user || null;
      state.token = action.payload?.token || null;
      state.adresse_facturation = action.payload?.adresse_facturation || null;
    },
    authRdv:(state,action)=>{
      state.isAuthenticatedRdv = action.payload || false;

    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateUserProfile.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action.payload;
        localStorage.setItem('user', JSON.stringify(action.payload));
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(changePassword.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(changePassword.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(changePassword.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteAccount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(deleteAccount.fulfilled, (state) => {
        state.loading = false;
        state.isAuthenticated = false;
        state.user = null;
        state.token = null;
        state.adresse_facturation = null;
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('adresse_facturation');
      })
      .addCase(deleteAccount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      //refresh token
      .addCase(refreshToken.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(refreshToken.fulfilled, (state, action) => {
        state.loading = false;
        state.token = action.payload.token;
        // Update user data if returned in response
        if (action.payload.user) {
          state.user = action.payload.user;
          localStorage.setItem('user', JSON.stringify(action.payload.user));
        }
        localStorage.setItem('token', action.payload.token);
      })
      .addCase(refreshToken.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        // Optional: logout user if refresh fails
        state.isAuthenticated = false;
        state.user = null;
        state.token = null;
        state.adresse_facturation = null;
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        localStorage.removeItem('adresse_facturation');
      })
  },

});
export const {
  loginStart,
  loginSuccess,
  updateUserData,
  registerPrestaSuccess,
  loginFailure,
  registerStart,
  registerSuccess,
  registerFailure,
  logout,
  initialize,
  authRdv,
} = userSlice.actions;

export default userSlice.reducer;